import { CoreIcon } from '../core-icon';
import timeFillSVG from '../../../src/images/icons/time-fill.svg';

export const TimeFillIcon = props => {
  return <CoreIcon src={timeFillSVG} {...props} />;
};
